import React from 'react';
import { Button } from '../ui';
import OriginationsBoardCard from './OriginationsBoardCard';
import OriginationsBoardEmptyState from './OriginationsBoardEmptyState';

const OriginationsBoardColumn = ({
  column,
  count = 0,
  isCommercialAction = false,
  isLoading = false,
  isLoaded = false,
  requests = [],
  canContinueRequest,
  canCompleteRequest,
  canDiscardRequest,
  canOpenObservations,
  onLoadDeferred,
  onViewProfile,
  onContinue,
  onComplete,
  onOpenObservations,
  onDiscard
}) => {
  const isDeferredPending = column.isDeferred && !isLoaded && !isLoading;

  return (
    <section
      className={`originations-board__column originations-board__column--${column.key}${isCommercialAction ? ' is-commercial-action' : ''}${column.isDeferred ? ' is-muted' : ''}`}
    >
      <header
        className="originations-board__column-header"
        title={column.shortDescription || column.description}
        aria-label={`${column.title}: ${column.shortDescription || column.description}`}
      >
        <div>
          <h2>{column.title}</h2>
        </div>
        <span className="originations-board__column-count">
          {isDeferredPending ? '-' : count}
        </span>
      </header>

      <div className="originations-board__column-body">
        {isDeferredPending ? (
          <div className="originations-board__deferred">
            <span>Cerradas se cargan bajo demanda.</span>
            <Button variant="outlineSecondary" size="sm" onClick={() => onLoadDeferred(column)}>
              Cargar
            </Button>
          </div>
        ) : isLoading ? (
          <OriginationsBoardEmptyState title="Cargando" description="Actualizando solicitudes..." compact />
        ) : requests.length === 0 ? (
          <OriginationsBoardEmptyState title="Sin solicitudes" compact />
        ) : (
          requests.map((request) => (
            <OriginationsBoardCard
              key={request.uid}
              request={request}
              column={column}
              canContinue={canContinueRequest(request)}
              canComplete={canCompleteRequest(request)}
              canDiscard={canDiscardRequest(request)}
              canOpenObservations={canOpenObservations(request)}
              onViewProfile={onViewProfile}
              onContinue={onContinue}
              onComplete={onComplete}
              onOpenObservations={onOpenObservations}
              onDiscard={onDiscard}
            />
          ))
        )}
      </div>
    </section>
  );
};

export default OriginationsBoardColumn;
